/**
 * Волна C (docs/MIGRATION_ROUTER.md §5). Было: <PrivateRoute path='/areas'>.
 */
import { createFileRoute } from '@tanstack/react-router';
import CacheDataRoute from '../CacheDataRoute';
import AreasPage from '@routes/Areas';

export const Route = createFileRoute('/areas')({
  component: () => <CacheDataRoute component={AreasPage} path='/areas' />
});
